import ErgAuthService, { createFakeAppToken } from '@ergeon/erg-auth';

import { API_HOST, AUTH_COOKIE_NAME, ID_SERVICE, LEVEL, MOCK_JWT } from '../envs';

const OPTIONAL_SETTINGS: Record<string, string> = {};

if (MOCK_JWT) {
  const fakeAppToken: string = createFakeAppToken(
    JSON.parse(MOCK_JWT), 'SOME_SECRET',
  );
  OPTIONAL_SETTINGS['mockJWT'] = fakeAppToken;
}

if (AUTH_COOKIE_NAME) {
  OPTIONAL_SETTINGS['cookieName'] = AUTH_COOKIE_NAME;
}

export const authService = new ErgAuthService({
  ...OPTIONAL_SETTINGS,
  appId: 'ergeon',
  idService: ID_SERVICE,
  userDetailsEndpoint: `${API_HOST}/api/v1/authenticate/help/`,
  level: LEVEL,
});
